import {EMDActions} from './EMDActions';

//Содержимое ADMS каталога
const initialEmdState = {
    members: [],            //Список полученных (отображаемых) элементов
    tags: [],               //Список тегов
    offset: 0,              //Семещения начиная с которых можно получить данные 
    limit: 20,              //Количество получаемых данных
    conditions: [],         //Массив условий отбора. Используется или
    repository: 1,          //NodId каталога, из которого получаются данные
    view: "catalog",        //Вид отображения: catalog - список элементов каталога, element - один элемент
    selected: {id: null},   //Данные по выбранному элементу
    load: false,            //Флаг загрузки данных
		content: undefined,     //Содержимое выбранного элемента ЕМД
		plantuml: {
			script: undefined,		// Скрипт для формирования картинки в plantuml 
			maked: false, 				// флаг формирования URL в plantuml и 
			url:null							// результат формирования (URL) картинки в plantuml 
		},					
}

export const emd = (state = { ...initialEmdState} , action) => {
    switch (action.type) {
        case EMDActions.LOAD_LIST_OK: 
            return {
                ...state,
                ...action.members,
                view: "catalog",
                load: true
            };
        case EMDActions.LOAD_LIST_STARTED: 
            return {
                ...state,
                members: [],
                view: "catalog",
                load: false
            }
        case EMDActions.LOAD_LIST_ERROR: 
            return {
                ...initialEmdState
            };

        case EMDActions.LOAD_ITEM_OK: 
            return {
                ...state,
                selected: {...action.selected},
                view: "element",
                load: false
            };

        case EMDActions.LOAD_ITEM_STARTED: 
            return {
                ...state,
                load: true
            };
        case EMDActions.LOAD_ITEM_ERROR: 
            return {
                ...state,
                view: "catalog",
                load: false
            };
        case EMDActions.CHANGE_CONDITIONS: 
            return {
                ...state,
                conditions: action.conditions,                
            };
        case EMDActions.LOAD_HISTORY_STARTED: 
            return {
                ...state,
                load: true
            };
        case EMDActions.LOAD_HISTORY_OK: 
            return {
                ...state,
                ...action.members,
                view: "history",
                load: true
            };
        case EMDActions.LOAD_HISTORY_ERROR: 
            return {
                ...state,
                view: "catalog",
                load: false
            };
        case EMDActions.LOAD_CONTENT_STARTED: 
            return {
                ...state,
                load: true
            };
        case EMDActions.LOAD_CONTENT_OK: 
            return {
                ...state,
                content: action.content,
                load: true
            };
        case EMDActions.LOAD_CONTENT_ERROR: 
            return {
                ...state,
                content: null,
                load: false
            };
        case EMDActions.PLANTUML_STARTED: 
            return {
                ...state,
                plantuml: {maked:false, script: undefined, url: null}
            };
        case EMDActions.PLANTUML_OK: 
            return {
                ...state,
                plantuml: {maked:true, script: action.script, url: action.url},
            };
        case EMDActions.PLANTUML_ERROR: 
            return {
                ...state,
                plantuml: {maked:false, script: action.script, url: null, error: action.error},
            };
        default:
            return state;
    }
}
